module.exports = __webpack_public_path__ + "img/home-page-02-sale-full-width.d77c4fea.jpg";